import { Grid, GridColumn } from "@progress/kendo-react-grid";
import React, { useContext, useEffect, useRef, useState } from "react";
import Scheduler from "./Scheduler";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router";
import AppContext from "../../../AppContext";
import { BASE_FILE_URL, BASE_URL } from "../../../constant";
import axios from "axios";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import KendoLoadingPanel from "../../KendoLoadingPanel";
import {
  DateTimePickerComponent,
  TimePickerComponent,
  DateRangePickerComponent,
} from "@syncfusion/ej2-react-calendars";
import { formatDate } from "@telerik/kendo-intl";
import { useTranslation } from "react-i18next";

const DateCell = (props) => {
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value:
          props.field === "startDate"
            ? new Date(e.target.value.setHours(0, 0, 0))
            : new Date(e.target.value.setHours(23, 59, 0)),
      });
    }
  };
  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field];

  return (
    <td>
      {dataItem.inEdit ? (
        <DateTimePickerComponent
          style={{
            width: "100%",
          }}
          min={props.ScheduleDetails.startDate}
          max={props.ScheduleDetails.endDate}
          format="dd/MM/yyyy"
          onChange={handleChange}
          value={dataValue}
        />
      ) : (
        formatDate(new Date(dataValue), "dd-MMM-yyyy")
      )}
    </td>
  );
};

const ActionColumn = (props) => {
  return (
    <td className="p-0 mx-auto" style={{ paddingLeft: "4px" }}>
      <button
        className="mx-auto"
        onClick={() => props.deleteItem(props.dataItem)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="red"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="red"
          class="w-4 h-4"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18 18 6M6 6l12 12"
          />
        </svg>
      </button>
    </td>
  );
};

const AssetScheduler = () => {
  const editField = "inEdit";
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  const { authCtx, superAdminCompany, setSuperAdminCompany, darkMode } =
    useContext(AppContext);
  const startTime = new Date(new Date().setHours(0, 0, 0));
  const endTime = new Date(new Date().setHours(23, 59, 0));
  const defaultWorkingDays = [
    // { id: "all", name: "All", selected: false, start: null, end: null },
    { id: 1, name: "Monday", selected: true, start: startTime, end: endTime },
    { id: 2, name: "Tuesday", selected: true, start: startTime, end: endTime },
    {
      id: 3,
      name: "Wednesday",
      selected: true,
      start: startTime,
      end: endTime,
    },
    { id: 4, name: "Thursday", selected: true, start: startTime, end: endTime },
    { id: 5, name: "Friday", selected: true, start: startTime, end: endTime },
    { id: 6, name: "Saturday", selected: false, start: null, end: null },
    { id: 0, name: "Sunday", selected: false, start: null, end: null },
  ];
  const [workingDays, setWorkingDays] = useState([
    { id: "all", name: "All", selected: false, start: null, end: null },
    ...defaultWorkingDays,
  ]);
  const [selectedAssetType, setSelectedAssetType] = useState();
  const [assetTypes, setAssetTypes] = useState([]);
  const [assets, setAssets] = useState([]);
  const scheduleObj = useRef();
  const [daysOffData, setDaysOffData] = useState([]);
  const [loading, setLoading] = useState({
    imageLoading: false,
    assetLoading: false,
    assetTypeLoading: false,
    scheduleLoading: false,
    formLoading: false,
  });
  const [scheduleData, setScheduleData] = useState([]);
  const [selectedAssets, setSelectedAssets] = useState();
  const [ScheduleDetails, setScheduleDetails] = useState({
    name: "",
    startDate: null,
    endDate: null,
    companyId:
      // authCtx.profile.role === 100
      //   ? superAdminCompany?.id
      //   :
      authCtx.profile?.companyId,
  });
  const [editMode, setEditMode] = useState(true);
  const [companies, setCompanies] = useState([]);

  const loadData = async () => {
    let assetData;
    setLoading((pre) => ({ ...pre, assetTypeLoading: true }));
    let res = await axios.get(`${BASE_URL}/Lookup/GetAllAssetTypes`);
    setAssetTypes(res.data);
    if (res.data.length > 0) {
      if (id === "new") {
        setSelectedAssetType(res.data[0]);
        loadAssets(res.data[0].id);
      }
    }
    setLoading((pre) => ({ ...pre, assetTypeLoading: false }));
    return res.data;
  };

  const loadAssets = async (assetId) => {
    setLoading((pre) => ({ ...pre, assetLoading: true }));
    const companyId =
      // authCtx.profile.role === 100
      //   ? superAdminCompany?.id
      //   :
      authCtx.profile?.companyId;
    const resData = await axios.get(
      `${BASE_URL}/api/Asset?assetTypeId=${assetId}&companyId=${companyId}&userRole=${authCtx.profile.role}`
    );
    const data = resData.data.map((asset, index) => {
      // Calculate hue based on index to ensure different colors for each asset
      let hue;
      if (index * (360 / resData.data.length) < 200) {
        hue = index * (360 / resData.data.length);
      } else {
        hue = (index * (360 / resData.data.length) + 60) % 360;
      }

      // Convert HSL color to RGB
      const color = `hsl(${hue}, 100%, 50%)`;

      return {
        ...asset,
        color: color,
      };
    });
    setAssets(data);
    if (id === "new") {
      const schedules = data.map((x) => ({
        assetId: x.id,
        assetName: x.name,
        schedules: [],
        weekDays: defaultWorkingDays,
        holidays: [],
      }));
      setScheduleData(schedules);
    }
    setLoading((pre) => ({ ...pre, assetLoading: false }));
    return data;
  };

  const itemChange = (event) => {
    const field = event.field || "";
    const newData = daysOffData.map((item) => {
      if (item.id === event.dataItem.id) {
        let modifiedItem = {
          ...item,
          [field]: event.value,
        };
        let dayDifference = 0;
        let inEdit = item.inEdit;
        if (modifiedItem.startDate && modifiedItem.endDate) {
          dayDifference = Math.ceil(
            (modifiedItem.endDate - modifiedItem.startDate) /
              (1000 * 60 * 60 * 24)
          );
          inEdit = false;
        }
        return { ...modifiedItem, daysOff: dayDifference, inEdit };
      } else {
        return item;
      }
    });
    setDaysOffData(newData);
    // refreshAllTemplate();
  };

  const ValidTable = () => {
    return daysOffData.every((x) => x.startDate !== null && x.endDate !== null);
  };

  const addNew = () => {
    if (ValidTable()) {
      let assetId;
      const newDataItem = {
        id: daysOffData.length + 1,
        inEdit: true,
        startDate: null,
        endDate: null,
        daysOff: 0,
        assetId,
      };
      setDaysOffData([
        newDataItem,
        ...daysOffData.map((item) => ({ ...item, inEdit: false })),
      ]);
    }
  };

  const deleteItem = (item) => {
    let index = daysOffData.findIndex(
      (record) => record.ProductID === item.ProductID
    );
    daysOffData.splice(index, 1);
    setDaysOffData([...daysOffData]);
  };

  const GetTotalDaysOff = () => {
    return daysOffData?.reduce((x, y) => x + y.daysOff, 0);
  };

  const onWeekDayClick = (item) => {
    if (item.id !== "all")
      setWorkingDays((pre) => {
        let finalData = pre.map((x) =>
          item.id === x.id
            ? {
                ...x,
                selected: !x.selected,
                start: item.selected ? null : startTime,
                end: item.selected ? null : endTime,
              }
            : x
        );
        finalData = finalData.map((x) =>
          x.id === "all"
            ? {
                ...x,
                selected: finalData
                  .filter((x) => x.id !== "all")
                  .every((x) => x.selected)
                  ? true
                  : false,
              }
            : x
        );
        return finalData;
      });
    else
      setWorkingDays((pre) =>
        pre.map((x) => ({
          ...x,
          selected: !item.selected,
          start: item.selected ? null : startTime,
          end: item.selected ? null : endTime,
        }))
      );
  };
  const onCloseClick = (e) => {
    navigate(`/assetSchedulerList`);
  };

  const handleAssetTypeChange = (e) => {
    setSelectedAssetType(e.target.value);
    loadAssets(e.target.value.id);
  };

  const handleAssetClick = (item) => {
    setSelectedAssets((pre) => {
      if (pre && pre.id === item.id) return null;
      else {
        const assetSchedule = scheduleData.find((x) => x.assetId === item.id);
        if (assetSchedule) {
          setDaysOffData(
            assetSchedule.holidays.map((x) => {
              let dayDifference = 0;
              if (x.startDate && x.endDate) {
                dayDifference = Math.ceil(
                  (new Date(new Date(x.endDate).setHours(23, 59, 0)) -
                    new Date(new Date(x.startDate).setHours(0, 0, 0))) /
                    (1000 * 60 * 60 * 24)
                );
              }
              return { ...x, daysOff: dayDifference };
            })
          );
          setWorkingDays([
            { id: "all", name: "All", selected: false, start: null, end: null },
            ...assetSchedule.weekDays,
          ]);
        }
        return item;
      }
    });
  };

  const loadScheduleData = async () => {
    const response = await axios.get(`${BASE_URL}/api/AssetScheduler/${id}`);
    if (response.status === 200) {
      const data = response.data;
      setScheduleDetails({
        name: response.data.name,
        startDate: new Date(response.data.startDate),
        endDate: new Date(response.data.endDate),
        companyId: response.data.companyId,
      });
      const assetTypeData =
        assetTypes.length > 0 ? assetTypes : await loadData();
      const assetType = assetTypeData.find(
        (x) => x.id === response.data.assetTypeId
      );
      setSelectedAssetType(assetType);
      const assetData = await loadAssets(assetType.id);
      // if (response.data.companyId)
      //   setSuperAdminCompany(
      //     companyData.find((x) => x.id === response.data.companyId)
      //   );
      setScheduleData(
        data.scheduleData
          .map((y) => {
            const asset = assetData.find((x) => x.id === y.assetId);
            if (asset)
              return {
                ...y,
                assetName: asset.name,
                schedules: y.schedules.map((x, i) => ({
                  Id: `${y.assetId}-${i}`,
                  StartTime: new Date(x.startTime),
                  EndTime: new Date(x.endTime),
                  assetId: y.assetId,
                  assetName: asset.name,
                  assetColor: asset.color,
                })),
              };
            else return null;
          })
          .filter((x) => x)
      );
      // setDaysOffData(data.holidays.map((x) => {}));
      setEditMode(false);
    }
  };
  const loadLookupData = async () => {
    let res = await axios.get(`${BASE_URL}/api/CompanyMaster`);
    if (res.status === 200) {
      const data = res.data;
      setCompanies(data);
      return data;
    }
  };

  useEffect(() => {
    if (id === "new") loadData();
  }, []);

  useEffect(() => {
    const loadCompanyDetails = async () => {
      const companyData = await loadLookupData();
      if (id === "new") {
        const company =
          // authCtx.profile.role === 100
          //   ? superAdminCompany
          //   :\
          companyData.find((x) => x.id === authCtx.profile.companyId);
        if (company) {
          setScheduleDetails((pre) => ({
            ...pre,
            companyId: company.id,
            companyName: company.name,
            company: company,
          }));
          loadAssets(selectedAssetType?.id);
        }
      } else {
        loadScheduleData();
      }
    };
    loadCompanyDetails();
  }, []);

  const onSave = async () => {
    setLoading((pre) => ({ ...pre, formLoading: true }));

    const payload = {
      id: id === "new" ? null : id,
      ...ScheduleDetails,
      scheduleData: scheduleData,
      assetTypeId: selectedAssetType.id,
      companyId:
        // authCtx.profile.role === 100
        //   ? superAdminCompany.id
        //   :
        authCtx.profile.companyId,
      companyName:
        // authCtx.profile.role === 100
        //   ? superAdminCompany?.name
        //   :
        companies.find((x) => x.id === authCtx.profile.companyId)?.name,
    };
    try {
      const response = await axios.post(
        `${BASE_URL}/api/AssetScheduler`,
        payload
      );
      if (response.status === 200) {
        navigate(`/assetScheduler/${response.data.id}`);
        toast.success("Successfully Saved Schedule");
      } else {
        toast.error("Some error occurred while saving");
      }
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error(error.response.data);
      } else {
        toast.error("An error occurred");
      }
    }
    setLoading((pre) => ({ ...pre, formLoading: false }));
  };

  const onGetScheduled = async () => {
    const timeZoneOffSet = new Date().getTimezoneOffset() / 60; // Convert minutes to hours
    const payload = {
      startDate: ScheduleDetails.startDate,
      endDate: ScheduleDetails.endDate,
      timeZoneOffSet,
      holidays: daysOffData.map((x) => ({
        startDate: new Date(
          new Date(x.startDate).setHours(0, 0, 0)
        ).toISOString(), // Set start time to midnight
        endDate: new Date(
          new Date(x.endDate).setHours(23, 59, 0)
        ).toISOString(),
      })),
      weekNamesCheckbox: workingDays
        .filter((x) => x.id !== "all")
        .map((x) => ({
          id: x.id,
          name: x.name,
          selected: x.selected,
          start: x.selected ? x.start : null,
          end: x.selected ? x.end : null,
        })),
    };
    setLoading((pre) => ({ ...pre, scheduleLoading: true }));
    const response = await axios.post(
      `${BASE_URL}/api/AssetScheduler/ScheduleTimeline`,
      payload
    );
    if (response.status === 200) {
      if (selectedAssets)
        setScheduleData((pre) => {
          const assetData = response.data.map((x, i) => ({
            Id: `${selectedAssets.id}-${i}`,
            StartTime: new Date(x.startTime),
            EndTime: new Date(x.endTime),
            assetId: selectedAssets.id,
            assetName: selectedAssets.name,
            assetColor: selectedAssets.color,
          }));
          const finalData = pre.map((x) =>
            x.assetId === selectedAssets.id
              ? {
                  ...x,
                  schedules: assetData,
                  weekDays: payload.weekNamesCheckbox,
                  holidays: payload.holidays,
                  assetName: selectedAssets.name,
                  assetColor: selectedAssets.color,
                }
              : x
          );
          return finalData;
        });
      else
        setScheduleData((pre) => {
          const finalData = pre.map((x) => ({
            ...x,
            schedules: response.data.map((y, i) => ({
              Id: `${x.assetId}-${i}`,
              StartTime: new Date(y.startTime),
              EndTime: new Date(y.endTime),
              assetId: x.assetId,
              assetName: assets.find((y) => y.id === x.assetId).name,
              assetColor: assets.find((y) => y.id === x.assetId).color,
            })),
            weekDays: payload.weekNamesCheckbox,
            holidays: payload.holidays,
          }));
          return finalData;
        });
      setEditMode(!editMode);
    }
    setLoading((pre) => ({ ...pre, scheduleLoading: false }));
  };

  const onTimeChange = (e, i, name) => {
    if (i === "all") {
      setWorkingDays((pre) => pre.map((x) => ({ ...x, [name]: e.value })));
    } else
      setWorkingDays((pre) =>
        pre.map((x) => (x.id === i ? { ...x, [name]: e.value } : x))
      );
  };

  const onAssetDelete = (id) => {
    setScheduleData((pre) => pre.filter((x) => x.assetId !== id));
  };

  const handleCompanyChange = (e) => {
    setScheduleDetails((pre) => ({
      ...pre,
      company: e.value,
      companyId: e.value.id,
    }));
  };

  return (
    <div className="flex flex-col relative text-white px-8 py-5 dark:bg-neutral-900 bg-lightModeBg h-full overflow-y-hidden">
      <div className="flex text-sm font-medium gap-3 items-center justify-between">
        <div className="flex gap-3 items-center">
          <button type="button" onClick={onCloseClick}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2.0"
              stroke={darkMode ? "white" : "black"}
              className="w-7 h-7"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          </button>
          <label className="text-xs lg:text-xl dark:text-white text-labels">
            {t("masters.headerTexts.assetScheduler")}
          </label>
        </div>
        <div className="flex gap-3 items-center">
          <label className="dark:text-white text-labels text-xs lg:text-sm font-medium">
            {t("masters.fields.name")}
            <span className=" text-red-600">&nbsp;*</span>
          </label>
          <input
            type="text"
            name="name"
            placeholder="Enter Name"
            value={ScheduleDetails.name}
            onChange={(e) =>
              setScheduleDetails((pre) => ({ ...pre, name: e.target.value }))
            }
            className="block dark:placeholder:text-neutral-400 placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg text-sm focus:outline-none dark:bg-[#363945] bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-52 h-8"
          />
          <label className="w-fit ml-5 dark:text-white text-labels">
            {t("masters.fields.scheduleTimeRange")}
            <span className=" text-red-600">&nbsp;*</span>
          </label>
          <div className="w-56 h-8">
            <DateRangePickerComponent
              onChange={(e) => {
                setScheduleDetails((pre) => ({
                  ...pre,
                  startDate: e.target.startValue,
                  endDate: e.target.endValue,
                }));
              }}
              value={
                ScheduleDetails.startDate && ScheduleDetails.endDate
                  ? [ScheduleDetails?.startDate, ScheduleDetails?.endDate]
                  : []
              }
              id="daterangepicker"
            />
          </div>
          {editMode ? (
            <button
              onClick={() => {
                onGetScheduled();
              }}
              type="button"
              disabled={
                !ScheduleDetails.startDate ||
                !ScheduleDetails.endDate ||
                loading.scheduleLoading ||
                scheduleData.length === 0
              }
              className="bg-blue-500 rounded-md px-3 h-8 cursor-pointer disabled:opacity-30"
            >
              {t("button.apply")}
            </button>
          ) : (
            <button
              onClick={() => {
                if (scheduleData.length > 0) {
                  const asset = assets.find(
                    (a) => a.id === scheduleData[0].assetId
                  );
                  handleAssetClick(asset);
                  // setSelectedAssets(asset);
                }
                setEditMode(!editMode);
              }}
              type="button"
              disabled={!ScheduleDetails.startDate || !ScheduleDetails.endDate}
              className="bg-blue-500 rounded-md w-16 h-8 cursor-pointer disabled:opacity-30"
            >
              {t("button.edit")}
            </button>
          )}
          {!editMode ? (
            <button
              onClick={() => onSave()}
              type="button"
              className="bg-green-500 rounded-md w-16 h-8 cursor-pointer disabled:opacity-40"
              disabled={
                loading.formLoading ||
                ScheduleDetails.name === "" ||
                scheduleData.length === 0
              }
            >
              {t("button.save")}
            </button>
          ) : null}
          {editMode ? (
            <button
              onClick={() => setEditMode(false)}
              type="button"
              className="bg-red-500 rounded-md w-16 h-8 cursor-pointer"
            >
              {t("button.cancel")}
            </button>
          ) : null}
          <button
            onClick={onCloseClick}
            type="button"
            className="bg-black border-neutral-800 border rounded-md w-16 h-8 cursor-pointer"
          >
            {t("button.close")}
          </button>
        </div>
      </div>
      {editMode ? (
        <div className="flex gap-5 dark:text-white text-labels mt-5 w-full h-[90%]">
          <div className="w-1/4 flex gap-3 h-full">
            <div className="flex flex-col gap-5 border-2 dark:border-neutral-800 border-gray2 rounded-md p-4 min-h-fit w-full">
              <div className="flex gap-4 items-center">
                <label className="font-medium">
                  {t("masters.headerTexts.assets")}
                </label>
                <div
                  className={`flex gap-4 font-medium text-gray-100 w-40 ${
                    darkMode ? "darkCombo" : "lightCombo"
                  }`}
                >
                  {id === "new" ? (
                    <ComboBox
                      data={assetTypes}
                      dataItemKey="id"
                      textField="name"
                      name="name"
                      placeholder="Select Asset Type"
                      suggest={true}
                      clearButton={false}
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                      }}
                      className="block placeholder:text-white border-gray-700 text-xs rounded-lg mb-4 dark:bg-[#363945] bg-inputFields text-white font-medium px-5  h-7"
                      onChange={handleAssetTypeChange}
                      value={selectedAssetType}
                    />
                  ) : (
                    <div className="px-3 border-l-2">
                      {selectedAssetType?.name}
                    </div>
                  )}
                </div>
              </div>
              <div className="text-xs px-1 h-full relative">
                <label className="font-medium">
                  {t("masters.labels.selectAssets")}
                </label>
                {(loading.assetLoading || loading.assetTypeLoading) && (
                  <KendoLoadingPanel />
                )}
                <div className="h-5/6 overflow-y-scroll no-scrollbar z-50  py-2 space-y-4">
                  {assets.length > 0 &&
                    scheduleData.map((x) => {
                      const asset = assets.find((a) => a.id === x.assetId);
                      return (
                        <div className="flex gap-1" key={x.id}>
                          <button
                            className={`flex border-l-8 gap-3 w-full rounded-md justify-between h-12 px-2 items-center ${
                              selectedAssets && selectedAssets.id === asset.id
                                ? "bg-blue-500"
                                : "dark:bg-gray-900 bg-inputFields hover:bg-cyan-600"
                            }`}
                            style={{ borderColor: asset.color }}
                            onClick={() => handleAssetClick(asset)}
                            key={asset.id}
                          >
                            <div className="flex gap-3">
                              {loading.imageLoading ? (
                                <div>
                                  <span class="inline-flex items-center gap-px">
                                    <span class="animate-blink mx-px h-1.5 w-1.5 rounded-full bg-neutral-600"></span>
                                    <span class="animate-blink animation-delay-200 mx-px h-1.5 w-1.5 rounded-full bg-neutral-600"></span>
                                    <span class="animate-blink animation-delay-[400ms] mx-px h-1.5 w-1.5 rounded-full bg-neutral-600"></span>
                                  </span>
                                </div>
                              ) : asset.imageId &&
                                !asset.imageId.startsWith("0000") ? (
                                <img
                                  src={`${BASE_FILE_URL}/${asset.imageId}`}
                                  alt="AssaetTypeIcon"
                                  className="h-auto w-12 image-full hover:fill-white"
                                />
                              ) : (
                                <img
                                  src="trucksvg.svg"
                                  alt="AsseeetTypeIcon1"
                                  className=" w-10 hover:fill-white"
                                />
                              )}
                              <div className="w-20 text-start">
                                <label className="font-medium">
                                  {asset.name}
                                </label>
                                <div className="text-xxs gap-2 flex items-center font-medium">
                                  <div
                                    className={`h-2 w-2  rounded-full ${
                                      asset.active
                                        ? selectedAssets &&
                                          selectedAssets.id === asset.id
                                          ? "bg-green-800"
                                          : "bg-green-600"
                                        : "bg-red-600"
                                    }`}
                                  ></div>
                                  {asset.active
                                    ? t("masters.labels.active")
                                    : t("masters.labels.inactive")}
                                </div>
                              </div>
                            </div>
                            <div className="pr-1 tooltip">
                              <span
                                className="tooltiptext text-xxs font-medium z-100 ml-11"
                                style={{ marginLeft: "-44px" }}
                              >
                                {!scheduleData.some(
                                  (y) => y.assetId === asset.id
                                )
                                  ? t("masters.labels.notScheduled")
                                  : t("masters.labels.scheduled")}
                              </span>
                              {!scheduleData.some(
                                (y) => y.assetId === asset.id
                              ) ? (
                                <img
                                  src="notScheduleIcon.svg"
                                  className="h-5"
                                />
                              ) : (
                                <img src="scheduleIcon.svg" className="h-5" />
                              )}
                            </div>
                          </button>
                          <button
                            type="button"
                            onClick={() => onAssetDelete(asset.id)}
                            className="flex justify-center items-center h-12 px-3 rounded-md dark:bg-gray-900 bg-inputFields"
                          >
                            <img src="delete-icon.svg" className="h-5" />
                          </button>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
          <div className="w-full h-full flex gap-5">
            <div
              className="border-2 dark:border-neutral-800 border-gray2 h-full w-2/5 rounded-md px-4 py-2 space-y-4"
              style={{
                borderLeftColor:
                  selectedAssets?.color || (darkMode ? "white" : "black"),
                borderLeftWidth: "4px",
              }}
            >
              <label className="font-medium">
                {selectedAssets
                  ? selectedAssets.name
                  : t("masters.labels.allAsset")}{" "}
                {t("masters.labels.workingDays")}
              </label>
              <div className="text-xs flex flex-col gap-3">
                <div className="flex font-medium">
                  <div className="w-full text-Start">
                    {t("masters.labels.day")}
                  </div>
                  <div className="w-96 text-center">
                    {t("masters.labels.start")}
                  </div>
                  <div className="w-96 text-center">
                    {t("masters.labels.end")}
                  </div>
                </div>
                {workingDays.map((x) => (
                  <div className="flex gap-3" key={x.id}>
                    <button
                      type="button"
                      onClick={() => onWeekDayClick(x)}
                      className={`flex justify-center w-full rounded-lg items-center border border-gray-800  disabled:opacity-50 h-full py-2 gap-2 pr-1 font-medium text-xs flex-col text-start 
                                  ${
                                    x.selected
                                      ? "bg-blue-500"
                                      : "dark:bg-gray-900 bg-inputFields hover:bg-cyan-600"
                                  }`}
                      disabled={
                        !ScheduleDetails.startDate || !ScheduleDetails.endDate
                      }
                    >
                      {x.name}
                    </button>
                    <TimePickerComponent
                      width={200}
                      id={`${x.id}+timeStart`}
                      name="start"
                      delayUpdate={false}
                      value={x.start}
                      onChange={(e) => onTimeChange(e, x.id, "start")}
                      max={x?.end || null}
                    />
                    <TimePickerComponent
                      width={200}
                      name="end"
                      id={`${x.id}+timeEnd`}
                      min={x.start || null}
                      value={x.end}
                      onChange={(e) => onTimeChange(e, x.id, "end")}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="h-full w-3/5 space-y-3">
              <label
                className="font-medium mb-6 px-3"
                style={{
                  borderLeftColor:
                    selectedAssets?.color || (darkMode ? "white" : "black"),
                  borderLeftWidth: "4px",
                }}
              >
                {selectedAssets
                  ? selectedAssets.name
                  : t("masters.labels.allAsset")}{" "}
                {t("masters.labels.daysoff")}:
              </label>
              <div className="flex justify-between mb-3 items-center text-xs font-medium pr-5">
                <button
                  onClick={addNew}
                  className="rounded-md dark:bg-neutral-800 bg-inputFields px-5 py-2 disabled:opacity-40"
                  disabled={
                    !ScheduleDetails.startDate || !ScheduleDetails.endDate
                  }
                >
                  + {t("button.addDayOff")}
                </button>
                <label className="">
                  {" "}
                  {t("masters.labels.total")} : {GetTotalDaysOff()}{" "}
                  {t("masters.labels.days")}
                </label>
              </div>
              <div
                className={`h-5/6 border-2 dark:border-neutral-800 rounded-md  ${
                  darkMode ? "darkGrid" : "lightGrid"
                }`}
              >
                <Grid
                  style={{
                    height: "100%",
                    width: "100%",
                    backgroundColor: "#181921",
                    borderRadius: "15px",
                    textAlign: "justify",
                  }}
                  editField={editField}
                  onItemChange={itemChange}
                  dataItemKey={"id"}
                  data={daysOffData}
                >
                  <GridColumn
                    key="startDate"
                    field="startDate"
                    title={t("masters.labels.start")}
                    filterable={false}
                    width="auto"
                    editor="date"
                    className="product-name"
                    cell={(props) => DateCell({ ...props, ScheduleDetails })}
                    format="{0:dd/MM/yyyy}"
                  />
                  <GridColumn
                    key="endDate"
                    field="endDate"
                    title={t("masters.labels.end")}
                    filterable={false}
                    // cell={column.cell}
                    width="auto"
                    format="{0:dd/MM/yyyy}"
                    cell={(props) => DateCell({ ...props, ScheduleDetails })}
                    editor="date"
                    className="product-name"
                  />
                  <GridColumn
                    key="daysOff"
                    field="daysOff"
                    title={t("masters.labels.daysoff")}
                    filterable={false}
                    editable={false}
                    //   cell={boolColumn}
                    width="80"
                    className="product-name"
                  />
                  <GridColumn
                    key="action"
                    field=""
                    title=""
                    editable={false}
                    filterable={false}
                    cell={(props) => ActionColumn({ ...props, deleteItem })}
                    width="40"
                    className="product-name"
                  />
                </Grid>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full mt-5 h-full flex flex-col gap-3">
          <label
            style={{
              borderLeftColor: selectedAssets?.color || "white",
              borderLeftWidth: "8px",
            }}
            className="font-medium px-3"
          >
            {selectedAssets ? selectedAssets.name : "All Asset"} Schedule
          </label>
          <Scheduler
            eventData={scheduleData}
            setEventsData={setScheduleData}
            scheduleObj={scheduleObj}
            assets={assets}
            selectedAsset={selectedAssets}
            renderType={"scheduleDetails"}
            scheduleId={"details-scheduler"}
            handleAssetClick={handleAssetClick}
          />
        </div>
      )}
      {/* <div className="flex items-center bg-inherit mt-7 py-1 gap-3 fixed bottom-2 w-11/12 justify-end">
        <button
          type="button"
          className="bg-white text-black text-xs lg:text-sm rounded-4xl px-10 lg:w-48 h-10"
          onClick={onCloseClick}
        >
          Close
        </button>
        <button
          type="button"
          className="bg-indigo-700 text-xs lg:text-sm rounded-4xl disabled:opacity-40 px-10 lg:w-48 h-10 flex justify-center items-center gap-3"
          onClick={() => (editMode ? onGetScheduled() : onSave())}
        >
          {/* {loading.formLoading && <BtnLoader />} */}
      {/* {editMode ? "Get Scheduled" : "Save"} */}
      {/* </button> */}
      {/* </div>  */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ToastContainer />
    </div>
  );
};

export default AssetScheduler;
